import { render } from "./NcrmDateTimeField.vue?vue&type=template&id=365c0e57&scoped=true"
import script from "./NcrmDateTimeField.vue?vue&type=script&lang=js"
export * from "./NcrmDateTimeField.vue?vue&type=script&lang=js"

import "./NcrmDateTimeField.vue?vue&type=style&index=0&id=365c0e57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365c0e57"]])

export default __exports__